import DownloadIcon from "@mui/icons-material/Download";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Box, Button, Stack, Typography } from "@mui/material";
import { formatDate } from "../../../../../../infrastructure/utils/formatters";
import { CONTRACT_UX } from "./contractUxTheme";

/**
 * Phase 7.7.4 — Compact contract specifications card.
 */
const ContractSummaryCard = ({ ux, onView, onDownload }) => {
  if (!ux || ux.phase === "empty") return null;

  const dateValue = ux.activatedAt || ux.signedAt || ux.createOn;

  return (
    <Box
      data-testid="contract-summary-card"
      dir="rtl"
      sx={{
        height: "100%",
        borderRadius: 2,
        bgcolor: "#fff",
        border: `1px solid ${CONTRACT_UX.cardBorder}`,
        px: CONTRACT_UX.cardPadding,
        py: 2,
      }}
    >
      <Typography variant="subtitle1" fontWeight={800} sx={{ mb: 1.5 }}>
        مشخصات قرارداد
      </Typography>

      <Stack spacing={1.1}>
        <Row label="شماره" value={ux.contractNumber || "—"} />
        <Row
          label="نسخه"
          value={ux.versionNumber != null ? String(ux.versionNumber) : "—"}
        />
        <Row label="تاریخ" value={dateValue ? formatDate(dateValue) : "—"} />
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 72 }}>
            وضعیت
          </Typography>
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor:
                  ux.phase === "active"
                    ? CONTRACT_UX.success
                    : ux.phase === "awaiting_guarantee" ||
                      ux.phase === "pending_signature"
                    ? CONTRACT_UX.warning
                    : CONTRACT_UX.primary,
              }}
            />
            <Typography variant="body2" fontWeight={700}>
              {ux.friendlyStatus}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 2 }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<DownloadIcon />}
          disabled={!ux.canDownload}
          onClick={onDownload}
          data-testid="contract-download-btn"
          sx={{
            bgcolor: CONTRACT_UX.primary,
            fontWeight: 700,
            "&:hover": { bgcolor: CONTRACT_UX.primaryDark },
          }}
        >
          دانلود PDF
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<VisibilityOutlinedIcon />}
          disabled={!ux.canDownload}
          onClick={onView}
          data-testid="contract-view-btn"
          sx={{
            borderColor: CONTRACT_UX.primary,
            color: CONTRACT_UX.primary,
            fontWeight: 700,
          }}
        >
          مشاهده قرارداد
        </Button>
      </Stack>
    </Box>
  );
};

const Row = ({ label, value }) => (
  <Stack direction="row" spacing={1} alignItems="baseline">
    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 72 }}>
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={700}>
      {value}
    </Typography>
  </Stack>
);

export default ContractSummaryCard;
